import styled from "styled-components";

export const TeamContainer = styled.div`
  display: flex;
  min-height: calc(100vh - 80px);
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #2b2e46;
  opacity: 0.9;
  padding: 10px 0;
`;
export const TeamH1 = styled.h1`
  font-size: 2.7rem;
  margin: 40px 0;
  color: #ffb400;

  @media screen and (max-width: 480px) {
    font-size: 2rem;
  }
`;

export const TeamP = styled.p`
  color: #fefefa;
  font-size: 1.5rem;
  text-align: center;
  padding: 0 20px;

  @media screen and (max-width: 480px) {
    font-size: 1rem;
  }
`;

export const TeamWrapper = styled.div`
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: center;
  grid-gap: 20px;
  padding: 60px 50px;

  @media screen and (max-width: 864px) {
    grid-template-columns: 1fr 1fr;
  }

  @media screen and (max-width: 620px) {
    grid-template-columns: 1fr;
    padding: 0 20px;
    margin: 60px auto;
  }
`;

export const TeamCardContainer = styled.div`
  background-color: #fefefa;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 10px;
  height: 300px;
  width: 240px;
  padding: 30px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  transition: all 0.2s ease-in-out;

  &:hover {
    transform: scale(1.02);
    transition: all 0.2s ease-in-out;
    cursor: pointer;
  }
`;
export const TeamPhoto = styled.img`
  height: 160px;
  width: 160px;
  border-radius: 10px;
  margin-bottom: 10px;
  border: 1px solid gray;

  filter: contrast(150%) saturate(50%);
`;

export const TeamH2 = styled.h2`
  font-size: 1rem;
  margin-bottom: 10px;
`;

export const TeamCardP = styled.p`
  font-size: 1rem;
  text-align: center;
  max-width: 160px;
`;
